export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/stickers.5903bad.svg";